import { Button, Form, Input, message } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateLeadInList } from "../../../redux/slices/leadSlice";

export const NameForm = ({ nameEditFormRef, loader, updateLead, setSelectedLead }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { selectedLead } = useSelector(state => state.lead);
  useEffect(() => {
    form.setFieldsValue({
      firstName: selectedLead.firstName,
      lastName: selectedLead.lastName,
    });
  }, [selectedLead]);
  const close = () => nameEditFormRef.current.click();
  const handleSaveLead = async values => {
    const res = await updateLead({
      variables: {
        leadId: selectedLead.id,
        ...values,
      },
    });
    if (res.data.updateLead.statusCode === 200) {
      close();
      message.success(res.data.updateLead.message);
      setSelectedLead({ ...selectedLead, ...res.data.updateLead.lead });
      dispatch(updateLeadInList(res.data.updateLead.lead));
    } else {
      message.error(res.data.updateLead.message);
    }
  };
  return (
    <Form layout="vertical" onFinish={handleSaveLead} className="w-[20rem]" form={form}>
      <Form.Item
        name="firstName"
        label="First name"
        rules={[{ required: true, message: "First name is required" }]}
      >
        <Input name="firstName" />
      </Form.Item>
      <Form.Item
        label="Last name"
        name="lastName"
        rules={[{ required: true, message: "last name is required" }]}
      >
        <Input name="lastName" />
      </Form.Item>
      <div className="flex-row-centered items-center gap-1 justify-start">
        <Button type="primary" loading={loader} htmlType="submit">
          Update
        </Button>
        <Button onClick={close} type="text">
          Cancel
        </Button>
      </div>
    </Form>
  );
};
